import { render, staticRenderFns } from "./datEmbededViewComplaints.vue?vue&type=template&id=3d15b040"
import script from "./datEmbededViewComplaints.vue?vue&type=script&lang=js"
export * from "./datEmbededViewComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports